export const BASE_URL = "https://cubo-challenge-servulo.herokuapp.com/"